import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import cross from "../../assets/img/cross.png";
import { createDeliveryPersonnel, getAreas } from "../../api/Api";
import { useTheme } from "@mui/material/styles";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60vw",
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: "none",
};

const AddDeliveryPersonModal = ({ open, handleClose, onSuccess }) => {
  const theme = useTheme();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [area, setArea] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [areas, setAreas] = useState([]);

  // Fetch the areas on component mount
  useEffect(() => {
    const fetchAreas = async () => {
      try {
        const response = await getAreas();
        const areasData = response.data.regions.map((region) => region.region_name);
        setAreas(areasData); // Set fetched areas
      } catch (error) {
        console.error("Error fetching areas:", error);
      }
    };

    fetchAreas();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const userData = {
      name,
      email,
      phone_number,
      area,
      password,
      rating: 1,
    };

    try {
      const response = await createDeliveryPersonnel(userData);
      console.log("Personnel added successfully:", response);
      
      if (onSuccess) onSuccess(response); // Trigger the onSuccess callback
      handleCloseModal();
    } catch (error) {
      console.error("Failed to add delivery personnel:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setName("");
    setEmail("");
    setPhone_number("");
    setArea("");
    setPassword("");
    setIsLoading(false); // Reset loading state
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="add-user-modal-title"
    >
      <Box sx={style} component="form" onSubmit={onSubmit}>
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: "20px",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography id="add-user-modal-title" variant="h6" component="h2">
            Add Delivery Personnel
          </Typography>
          <Box
            component="img"
            src={cross}
            alt="Close"
            sx={{
              width: "30px",
              height: "30px",
              cursor: "pointer",
            }}
            onClick={handleCloseModal}
          />
        </Box>
        <Box sx={{ padding: "20px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Phone Number"
                value={phone_number}
                onChange={(e) => setPhone_number(e.target.value)}
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Delivery Area</InputLabel>
                <Select
                  value={area}
                  onChange={(e) => setArea(e.target.value)}
                  label="Delivery Area"
                  required
                >
                  {areas.map((areaName, index) => (
                    <MenuItem key={index} value={areaName}>
                      {areaName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="flex-end">
                <Button
                  type="submit"
                  variant="contained"
                  disabled={isLoading}
                  sx={{
                    width: "20%",
                    mt: 2,
                    padding: "15px",
                    backgroundColor: isLoading ? "#aaa" : "#FF893A",
                  }}
                >
                  {isLoading ? "Please wait..." : "Save Data"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddDeliveryPersonModal;
